import styled from 'styled-components';

const Spinner = styled.div`
  animation: spinner 1.2s linear infinite;
  border: 5px solid #fff;
  border-color: ${({ c }) => c || '#fff'} transparent ${({ c }) => c || '#fff'} transparent;
  border-radius: 50%;
  content: ' ';
  height: ${({ h }) => h || '20px'};
  visibility: ${({ show }) => (show ? 'visible' : 'hidden')};
  width: ${({ w }) => w || '20px'};

  @keyframes spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Spinner.js